import React from 'react';
import {Typography} from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import { Card, Box } from '@mui/material';
import { Container } from '@mui/material';

const AboutDesktop = () => {
  return (
    <Container disableGutters>
      <Typography variant="h4" marginTop={6}>
          Üdvözlöm a Tom-House oldalán!
      </Typography>
      <Typography margin={2}></Typography>      
          <Typography variant="h6">
            <Typography variant="h6">
            Hutoczky Tamás vagyok, egy lelkes és elkötelezett ács, aki már 4 éve dolgozik a szakmában. Az elmúlt évek során számos projektben vettem részt, amelyek során jelentős tapasztalatra tettem szert különböző ácsmunkák terén.
            Szívesen állok az Ön rendelkezésére is, elsősorban a Csepel-szigeten és vonzáskörzetében.          
            </Typography>
            <Grid container spacing={3} marginTop={4} justifyContent="center">              
              <Box boxShadow={4}>
                <Card>
                  <CardMedia component="img" src='https://tom-house-huc6gadgb3c4cac8.z03.azurefd.net/images/tomi.png' alt='Rólam' />          
                </Card>
              </Box>          
            </Grid>
            <Typography variant="h4" marginTop={6}>Szolgáltatásaim</Typography>
            <Grid container spacing={3} columns={16} marginTop={4} justifyContent="center">
              <Grid item xs={16} sm={12} md={8} >
                <Box margin={2} boxShadow={4} padding={4} sx={{ bgcolor: 'white', color: 'black' }}>
                <Typography variant="h4" marginBottom={4} >Tetőfedés</Typography>
                <Typography variant="h8" marginTop={4}>Professzionális tetőfedési megoldásokat kínálok, amelyek nemcsak esztétikusak, de tartósak és megbízhatóak is. Legyen szó új tetőről vagy meglévő tető felújításáról, vagy javításáról, számíthat rám.</Typography>
                <Card>
                  <CardMedia component="img" src='./images/tetofedes.png' alt='Tetőfedés' />          
                </Card>
                </Box>
              </Grid>
              <Grid item xs={16} sm={12} md={8} >
                <Box margin={2} boxShadow={4} padding={4} sx={{ bgcolor: 'white', color: 'black' }}>
                  <Typography variant="h4" marginBottom={4}>Autóbeállók</Typography>
                  <Typography variant="h8" marginTop={4}>Egy jól megtervezett és megépített autóbeálló nemcsak védi járművét az időjárás viszontagságaitól, de növeli az ingatlan értékét is. Modern és praktikus megoldásokkal állok rendelkezésére.</Typography>
                  <Card>
                    <CardMedia component="img" src='./images/autobeallo.png' alt='Autóbeállók készítése' />          
                  </Card>
                </Box>
              </Grid>
              <Grid item xs={16} sm={12} md={8} >
              <Box margin={2} boxShadow={4} padding={4} sx={{ bgcolor: 'white', color: 'black' }}>
                <Typography variant="h4" marginBottom={4}>Előtetők</Typography>
                <Typography variant="h8" marginTop={4}>Az előtetők nemcsak esztétikus kiegészítői lehetnek otthonának, hanem praktikus védelmet is nyújtanak az eső és a napsugárzás ellen. Egyedi igényekre szabott előtetőket készítek.</Typography>
                <Card>
                  <CardMedia component="img" src='./images/terasz.png' alt='Előtetők készítése' />          
                </Card>
                </Box>
              </Grid>
              <Grid item xs={16} sm={12} md={8} >
              <Box margin={2} boxShadow={4} padding={4} sx={{ bgcolor: 'white', color: 'black' }}>
                <Typography variant="h4" marginBottom={4}>Könnyűszerkezetes házak</Typography>
                <Typography variant="h8" marginTop={4}>Az energiatakarékos és gyorsan kivitelezhető könnyűszerkezetes házak egyre népszerűbbek és gyorsan kivitelezhetők. Bízza rám álmai otthonának megvalósítását vagy bővítését.</Typography>
                <Card>
                  <CardMedia component="img" src='./images/ksz1.jpg' alt='Könnyűszerkezetes házak' />          
                </Card>
                </Box>
              </Grid>    
              <Typography variant="h6" marginTop={4} marginLeft={6}>
                Munkám során mindig nagy hangsúlyt fektetek a minőségre, a precizitásra és az ügyfeleim elégedettségére. Hiszem, hogy a jól végzett munka és a tisztességes hozzáállás a siker kulcsa.
                Ha bármilyen kérdése van, vagy szeretne többet megtudni szolgáltatásaimról, kérem, ne habozzon kapcsolatba lépni velem. Örömmel állok rendelkezésére!
              </Typography>
            </Grid>
          </Typography>
      <Typography margin={6}></Typography>
    </Container>    
  );
};

export default AboutDesktop;
